import React from 'react';
import { OrganisationAssignmentDto } from 'models/dtoTypes';
import { date2str } from 'utils/date';
import { styled } from '@mui/material/styles';
import ResourceDetailContainer, { ITab } from 'kosmos/components/ResourceDetailContainer';
import { RouteComponentProps, withRouter } from 'react-router';
import { GetOrganisationAssignment } from 'services/organisationAssignment';

const PREFIX = 'SmartGovernanceDetailPage';

const classes = {
  root: `${PREFIX}-root`,
  pageHeader: `${PREFIX}-pageHeader`,
};

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(5),
  width: '100%',

  [`& .${classes.pageHeader}`]: {
    width: '100%',
    position: 'relative',

    '& > button': {
      position: 'absolute',
      right: 0,
      top: 0,
    },
  },
}));

function SmartGovernanceDetailPage(props: RouteComponentProps<{ id: string }>): JSX.Element {
  const id = props.match.params.id;
  console.log(id);
  const [tabId, setTabId] = React.useState('details');

  const generateTabs = (): ITab<OrganisationAssignmentDto>[] => [
    {
      id: 'details',
      title: 'Details',
      getUiSchema: () => ({
        fields: [
          {
            label: 'Id',
            name: 'id',
            readonly: true,
            widget: 'text',
          },
          {
            label: 'Organisation',
            name: 'organisationId',
            readonly: false,
            formatter: (organisationId: string, attributes: OrganisationAssignmentDto) =>
              attributes.organisationId,
            widget: 'organisationSelector',
          },
          {
            label: 'Company Id',
            name: 'kosmosCompanyId',
            readonly: true,
            widget: 'text',
          },
          {
            label: 'Assigner',
            name: 'assignerId',
            readonly: true,
            widget: 'text',
          },
          {
            label: 'Accepted By',
            name: 'acceptUserId',
            readonly: true,
            widget: 'text',
          },
          {
            label: 'Created At',
            formatter: (datestr: string) => date2str(datestr, 'DD MMM YYYY, HH:mm'),
            name: 'created',
            readonly: true,
            widget: 'text',
          },
          {
            label: 'Last Updated At',
            name: 'updated',
            formatter: (datestr: string) => date2str(datestr, 'DD MMM YYYY, HH:mm'),
            readonly: true,
            widget: 'text',
          },
        ],
      }),
    },
  ];

  const handleFetch = async (): Promise<OrganisationAssignmentDto> => {
    return await GetOrganisationAssignment(id);
  };

  // const handleUpdate = async (attrs: { organisationId?: string }): Promise<OrganisationAssignmentDto> => {
  //   const user = await UpdateUser(id, attrs);
  //   return user;
  // };

  return (
    <Root>
      <ResourceDetailContainer
        tabs={generateTabs()}
        breadcrumbText="Smart Governances"
        breadcrumbUrl="/smart_governances"
        onTabChanged={setTabId}
        onFetch={handleFetch}
        //onUpdate={handleUpdate}
        currentTabId={tabId}
        displayNameKey="email"
      />
    </Root>
  );
}

export default withRouter(SmartGovernanceDetailPage);
